import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { TableCell, TableRow } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ThinCheckbox } from 'components/common/Styles';
import { ADMIN_DMS_READ, ADMIN_DMS_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const ContentTypesComponent = ({ data, onDelete }) => {
  const canRead = usePermission(ADMIN_DMS_READ);
  const canWrite = usePermission(ADMIN_DMS_WRITE);
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const navigateToContentType = useCallback(() => {
    historyContext.push(`/contentTypes/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell size='small'>
        <Typography title={data.code}>{data.code}</Typography>
      </TableCell>
      <TableCell size='small'>
        <Typography title={data.name}>{data.name}</Typography>
      </TableCell>
      <TableCell align='center'>
        <ThinCheckbox checked={data.isFileType} disabled />
      </TableCell>
      <TableCell align='right'>
        <IconButton color='primary' variant='text' size='small' tooltip={t('Edit')} disabled={!canRead} onClick={navigateToContentType}>
          <Edit fontSize='small' />
        </IconButton>
        <IconButton
          color='primary'
          size='small'
          variant='text'
          type='delete'
          tooltip={t('Delete')}
          disabled={!canWrite}
          onClick={() => onDelete(data.id)}
        />
      </TableCell>
    </TableRow>
  );
};

ContentTypesComponent.propTypes = {
  data: PropTypes.object,
  onDelete: PropTypes.func.isRequired
};

export default ContentTypesComponent;
